import classNames from "classnames"
import ApplicationComponent from "legacy/ApplicationComponent"
import { humanize } from "legacy/helpers.es6"
import _ from "lodash"
import PropTypes from "prop-types"
import React from "react"
import caratImage from "src/assets/custom-icons/carat.svg"

class SortButtonsBar extends ApplicationComponent {
  renderSortButton(sortName, buttonTitle) {
    const isActive = this.props.sort === sortName
    const sortOrder = isActive
      ? this.props.sortOrder === "asc"
        ? "desc"
        : "asc"
      : "asc"
    const sortOrderClasses = {
      asc: "transform rotate-180 ease-in-out duration-200",
      desc: "ease-in-out duration-200",
    }
    return (
      <button
        key={sortName}
        type="button"
        className={`btn btn-sm btn-${
          isActive ? "primary" : "gray"
        } text-bold flex-1`}
        onClick={() => this.props.updateSort(sortName, sortOrder)}
      >
        <span className={classNames({ "pr-1": isActive })}>
          {humanize(buttonTitle || sortName)}
        </span>
        {isActive && (
          <img
            alt=""
            className={sortOrderClasses[sortOrder]}
            src={caratImage}
          />
        )}
      </button>
    )
  }

  render() {
    return (
      <div className="flex items-center space-x-1 space-y-3 md:space-x-3">
        <p className="m-0 self-end text-sm font-bold md:text-base">Sort by</p>
        {_.map(this.props.buttons, (button) =>
          this.renderSortButton(button.name, button.title)
        )}
      </div>
    )
  }
}

SortButtonsBar.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      title: PropTypes.string,
    })
  ).isRequired,
  sort: PropTypes.string.isRequired,
  sortOrder: PropTypes.string.isRequired,
  updateSort: PropTypes.func.isRequired,
}

export default SortButtonsBar
